import { render, staticRenderFns } from "./genemodels.vue?vue&type=template&id=2297d0cc&"
import script from "./genemodels.vue?vue&type=script&lang=js&"
export * from "./genemodels.vue?vue&type=script&lang=js&"
import style0 from "./genemodels.vue?vue&type=style&index=0&id=2297d0cc&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports